/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const IncidentSearchPeriod = {
    Any: 'Any',
    PastWeek: 'PastWeek',
    PastMonth: 'PastMonth',
    PastYear: 'PastYear'
};
export function IncidentSearchPeriodFromJSON(json) {
    return IncidentSearchPeriodFromJSONTyped(json, false);
}
export function IncidentSearchPeriodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function IncidentSearchPeriodToJSON(value) {
    return value;
}
